"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableEmptyState = TableEmptyState;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
function TableEmptyState(props) {
    var message = props.message, _a = props.icon, icon = _a === void 0 ? "solar:inbox-linear" : _a;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center gap-2 py-16 text-center", children: [(0, jsx_runtime_1.jsx)(react_1.Icon, { icon: icon, fontSize: 32, className: "text-medium-gray" }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-medium-gray", children: message })] }));
}
